import React from 'react';
import { Box, Typography } from '@mui/material';

interface BottomSectionProps {
  Icon: any;
  color: string;
  text: string;
}

export const BottomSection = ({
  Icon,
  color,
  text,
}: BottomSectionProps) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      fontSize: '16px',
      color,
    }}>
      <Icon fontSize="inherit"/>
      <Typography sx={{
        fontSize: '12px',
        fontWeight: '400',
        marginLeft: '6px',
      }}>
        {text}
      </Typography>
    </Box>
  )
}
